// `this.$cookie` as vue-cookie 1 provided it (`set(name, value, { expires })`, `get(name)`, `delete(name)`).
// The app only writes `previousUrl` before a download so the download page can offer a way back; the cookie is
// read server-side, so it is written for the whole site.
const UNITS = { s: 1000, m: 60 * 1000, h: 60 * 60 * 1000, d: 24 * 60 * 60 * 1000 };

function expiresAt(expires) {
  if (expires instanceof Date) return expires;
  if (typeof expires === 'number') return new Date(Date.now() + expires * UNITS.d);
  const match = /^(\d+)([smhd])$/.exec(String(expires || '').trim());
  if (match) return new Date(Date.now() + Number(match[1]) * UNITS[match[2]]);
  return null;
}

export default {
  set(name, value, { expires, path = '/' } = {}) {
    const at = expiresAt(expires);
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=${path}${at ? `; expires=${at.toUTCString()}` : ''}`;
  },

  get(name) {
    const prefix = `${encodeURIComponent(name)}=`;
    const found = document.cookie.split('; ').find((part) => part.startsWith(prefix));
    return found ? decodeURIComponent(found.slice(prefix.length)) : null;
  },

  delete(name, { path = '/' } = {}) {
    document.cookie = `${encodeURIComponent(name)}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  },
};
